"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateString = void 0;
const tslib_1 = require("tslib");
const luxon = tslib_1.__importStar(require("luxon"));
function formatDateString(date, timezone) {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return luxon.DateTime.fromJSDate(date, { zone: timezone }).startOf('second').toISO({ suppressMilliseconds: true });
}
exports.formatDateString = formatDateString;
//# sourceMappingURL=format-date.js.map